import { useEffect } from 'react'
import { subscribeTagReads } from '../services/scannerService'
import { useTagSkuScanStore } from '../stores/tagSkuScanStore'

/** Hardware TagRead → Engine tag↔SKU scan pool. */
export function useTagSkuScanSubscription(enabled: boolean) {
  const ingestTag = useTagSkuScanStore((s) => s.ingestTag)

  useEffect(() => {
    if (!enabled) return
    return subscribeTagReads((tagId) => ingestTag(tagId))
  }, [enabled, ingestTag])
}
